import styled from 'styled-components';
import { breakpoint } from '../theme/breakpoint';

export const Heading = styled.h2`
  margin-top: 0;
  margin-bottom: ${({ theme }) => theme.spacing.standard};
  color: inherit;
`;

export const Wrapper = styled.div`
  margin: 0;
`;

export const ListWrapper = styled.ul`
  width: 100%;
  padding: 0;

  ${breakpoint.tablet`
    columns: ${({ $columns }) => $columns};
  `};
`;

export const ListItem = styled.li`
  list-style: none;
  margin-bottom: ${({ theme }) => theme.spacing.tiny};
  padding-right: ${({ theme }) => theme.spacing.standard};
  font-size: ${({ theme }) => theme.fontsize.base};
  font-weight: ${({ theme }) => theme.fontWeight.normal};
  text-decoration: none;
  /* padding to allow for focus styles to be visible */
  padding-top: 4px;
  padding-bottom: 2px;
`;
